import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useTaxes = () => {
  const urlStr = `${getApiUrl()}/tax`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const response = await axios.get(url);
        return response.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostTax = () => {
  const postTax = async (payload) => {
    try {
      const url = `${getApiUrl()}/mega/tax`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postTax;
};

export const usePutTax = () => {
  const putTax = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/mega/tax/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putTax;
};

export const useDeleteTax = () => {
  const deleteTax = async (id) => {
    try {
      const url = `${getApiUrl()}/mega/tax/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return deleteTax;
};
